import type { FC } from 'react';
import React, { useMemo, useEffect, useState } from 'react';
import cn from 'classnames';
import { useForm } from 'react-final-form';

import { applicationsCashbackCategoriesApi } from '../../api/applications-cashback';

import { onSentryCaptureException } from './helpers';
import type { ICashbackForMonth, TCashback } from './models';
import type { TStatus } from './components/cashback-categories/models';

export const Cashback: FC<TCashback> = ({
    CashbackCategories,
    CashbackPackages,
    Tab,
    TabsPanel,
    carousel,
    cashbackCategories,
    cashbackPackages,
    className,
    config,
    styles,
}) => {
    const [status, setStatus] = useState<TStatus>('loading');
    const [cashbackData, setCashbackData] = useState<ICashbackForMonth>();
    const formApi = useForm();

    useEffect(() => {
        if (!cashbackCategories) return;

        applicationsCashbackCategoriesApi(cashbackCategories.groupType)
            .then(response => {
                setCashbackData(response.data[0]);
                setStatus('success');
            })
            .catch(err => {
                setStatus('error');
                onSentryCaptureException(err);
            });
    }, [cashbackCategories]);

    const categories = useMemo(() => {
        if (!cashbackCategories) return null;

        formApi.change('selectedCashbackType', 'categories');

        return (
            <CashbackCategories
                cashbackData={cashbackData}
                isTabs={!!cashbackPackages}
                settings={cashbackCategories}
                status={status}
            />
        );
    }, [CashbackCategories, cashbackCategories, cashbackPackages, cashbackData, formApi, status]);

    const packages = useMemo(() => {
        if (!cashbackPackages) return null;

        formApi.change('selectedCashbackType', 'package');

        return <CashbackPackages {...cashbackPackages} carousel={carousel} />;
    }, [CashbackPackages, carousel, cashbackPackages, formApi]);

    const tab = useMemo(() => packages || categories, [packages, categories]);

    if (packages && categories) {
        if (status === 'error') {
            formApi.change('selectedCashbackType', 'package');
        }

        return (
            <TabsPanel
                className={cn(styles.tabs, styles.external, className)}
                keepMounted
                onChange={selected => formApi.change('selectedCashbackType', selected.id)}
                selectedID={status === 'error' ? 'package' : 'categories'}
                theme="light"
            >
                <Tab
                    className={cn(styles.tab, styles.external)}
                    id={'categories'}
                    styler={config.tabOffset}
                    title="Категории"
                >
                    {categories}
                </Tab>
                <Tab
                    className={cn(styles.tab, styles.external)}
                    id={'package'}
                    styler={config.tabOffset}
                    title="Готовый пакет"
                >
                    {packages}
                </Tab>
            </TabsPanel>
        );
    }

    if (tab) {
        return <div className={className}>{tab}</div>;
    }

    return null;
};
